import { render } from "./RestoreItem.vue?vue&type=template&id=6e106046"
import script from "./RestoreItem.vue?vue&type=script&lang=js"
export * from "./RestoreItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__